export const API_URL = "https://glemo-admin-service-qas.azurewebsites.net/api"
// hml
// export const API_URL = "https://glemo-admin-service-hml.azurewebsites.net/api"
// local
// export const API_URL = "https://localhost:7135/api"
export const MAIL_API_URL = 'http://frontend-glemo.web21f104.uni5.net/'
